import React from 'react';
import { NextPage } from 'next';
import { GetTermsAPI } from 'api/site';

const Privacy: NextPage = ({ data }: any) => {
  return (
    <section style={{ margin: '0 32px' }}>
      <div dangerouslySetInnerHTML={{ __html: data.text }} />
    </section>
  );
};

Privacy.getInitialProps = async () => {
  const { data } = await GetTermsAPI('privacy');

  return { data };
};

export default Privacy;
